/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-nested-ternary */
import React from 'react'

import { FieldProps } from 'formik'

import { TextField, TextFieldProps } from '@material-ui/core'
import MuiAutocomplete, {
  AutocompleteProps as MuiAutocompleteProps,
} from '@material-ui/lab/Autocomplete'

import { useTextField } from '../TextField/TextField'

// prettier-ignore
export interface AutocompleteProps<
  T,
  Multiple extends boolean | undefined,
  DisableClearable extends boolean | undefined,
  FreeSolo extends boolean | undefined
> extends FieldProps,
    Omit<
      MuiAutocompleteProps<T, Multiple, DisableClearable, FreeSolo>,
      'name' | 'value' | 'defaultValue'
    > {}

export function fieldToAutocomplete<
  T,
  Multiple extends boolean | undefined,
  DisableClearable extends boolean | undefined,
  FreeSolo extends boolean | undefined
>({
  disabled,
  field,
  form: { isSubmitting, setFieldValue },
  onChange,
  onBlur,
  freeSolo,
  onInputChange,
  ...props
}: AutocompleteProps<T, Multiple, DisableClearable, FreeSolo>): MuiAutocompleteProps<
  T,
  Multiple,
  DisableClearable,
  FreeSolo
> {
  const { multiple: _multiple, ...fieldSubselection } = field

  return {
    freeSolo,
    disabled: disabled ?? isSubmitting,
    loading: isSubmitting,
    ...fieldSubselection,
    ...props,
    onBlur:
      onBlur ||
      function OnEvent(event) {
        field.onBlur(event ?? field.name)
      },
    onInputChange: onInputChange
      ? function OnEvent(...args) {
          setFieldValue(field.name, args[1])
          onInputChange(...args)
        }
      : freeSolo
      ? function OnEvent(_event, value) {
          setFieldValue(field.name, value)
        }
      : undefined,
    onChange:
      onChange ||
      (!freeSolo
        ? function OnEvent(_event, value) {
            setFieldValue(field.name, value)
          }
        : undefined),
  }
}

export default function Autocomplete<
  T,
  Multiple extends boolean | undefined,
  DisableClearable extends boolean | undefined,
  FreeSolo extends boolean | undefined
>(props: AutocompleteProps<T, Multiple, DisableClearable, FreeSolo> & TextFieldProps) {
  const autocompleteProps = fieldToAutocomplete(props)
  const tfProps = useTextField(props)
  return (
    <MuiAutocomplete
      {...autocompleteProps}
      renderInput={(params) => {
        return (
          <TextField
            name={props.field.name}
            error={!!tfProps.helperText}
            helperText={tfProps.helperText}
            label={props.label}
            variant="outlined"
            {...params}
            autoComplete="new-password"
            inputProps={{
              ...params.inputProps,
              'data-hook': props.field.name,
            }}
          />
        )
      }}
    />
  )
}

Autocomplete.displayName = 'FormikMaterialUIAutocomplete'
